import { Component, inject, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '@envs/environment';

@Component({
  selector: 'app-not-found',
  imports: [TranslateModule],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
})
export class NotFoundComponent implements OnInit {
  private readonly translate = inject(TranslateService);
  urlApp = environment.appurl;
  constructor() {
    if (localStorage.getItem('language') === null) {
      this.translate.setDefaultLang('es');
      localStorage.setItem('language', 'es');
    } else {
      this.translate.setDefaultLang(localStorage.getItem('language')!);
    }
  }

  ngOnInit(): void {}
}
